import { useGetChartData, useGetCollectionOwnerStats } from '../../hooks/useGetChartData';
import { ChartComponent } from '../ActivityCharts';
import { OwnerStatsTable } from '../OwnerStatsTable';
import { CollectionDepthChart } from './CollectionDepthChart';
import { CollectionRarityRangeStats } from './collection_rarity_range';

const groupBy = function (xs, key) {
  if (!xs) return {};
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const CollectionCharts = ({ collectionAddress }) => {
  const { data: swr } = useGetChartData(collectionAddress);
  const { data: ownerStats } = useGetCollectionOwnerStats(collectionAddress);
  const { data } = swr || {};

  const groupedData = groupBy(data, 'key');
  return (
    <>
      <CollectionDepthChart collectionAddress={collectionAddress} data={groupedData.depth} />
      <div className='mt-3 flex-wrap gap-3 px-0 md:grid md:grid-cols-2'>
        {Object.values(groupedData).map((d, i) => {
          console.log(d[0].key);
          return !['depth', 'rarityRankRanges'].includes(d[0].key) ? (
            <div key={`${collectionAddress}chart${i}`} className='mb-0 mt-3 w-full md:mt-0'>
              {<ChartComponent statsData={d} />}
            </div>
          ) : null;
        })}
      </div>
      <CollectionRarityRangeStats
        collectionAddress={collectionAddress}
        setFilter={(val) => {
          //setFilterVal(val);
          //setFilterEverUsed(true);
        }}
      />
      <div className=''>
        <OwnerStatsTable ownerStats={ownerStats} />
      </div>
    </>
  );
};
